const ACTIONS = {
    PROFILE: "profile",
    FRIENDS: "friends",
    FOLLOWERS: "followers"
};

export default ACTIONS;